import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ButtonBase from '@material-ui/core/ButtonBase';
import ProductImage from '../ProductImage';
var useStyles = makeStyles(function (theme) {
  return {
    image: {
      maxWidth: 60,
      maxHeight: 60,
      verticalAlign: 'middle'
    },
    root: {
      position: 'relative',
      display: 'inline-block',
      padding: theme.spacing(1)
    },
    shadow: {
      width: 0,
      height: 0
    }
  };
}, {
  name: 'SxComProductImageGalleryThumbnailsItem'
});

function ProductImageGalleryThumbnailsItem(_ref) {
  var altDefault = _ref.altDefault,
      pClasses = _ref.classes,
      className = _ref.className,
      media = _ref.media,
      mediaTypeComponents = _ref.mediaTypeComponents,
      handleClick = _ref.onClick,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["altDefault", "classes", "className", "media", "mediaTypeComponents", "onClick", "size"]);

  var classes = useStyles({
    classes: pClasses
  });
  var _media$alt = media.alt,
      alt = _media$alt === void 0 ? altDefault : _media$alt,
      src = media.src,
      type = media.type;
  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, rest, {
    component: "div",
    onClick: handleClick,
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement(ProductImage, {
    alt: alt,
    src: src,
    type: type,
    mediaTypeComponents: mediaTypeComponents,
    className: classes.image,
    size: size,
    shape: "square"
  }));
}

ProductImageGalleryThumbnailsItem.propTypes = {
  altDefault: PropTypes.arrayOf(PropTypes.shape({})),
  classes: PropTypes.shape({
    image: PropTypes.string,
    root: PropTypes.string,
    shadow: PropTypes.string
  }),
  className: PropTypes.string,
  media: PropTypes.shape({
    alt: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({
      language: PropTypes.string.isRequired,
      text: PropTypes.string
    }))]),
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))]).isRequired,
    type: PropTypes.string
  }).isRequired,
  mediaTypeComponents: PropTypes.shape({}),
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['mini', 'small', 'normal', 'big'])
};
ProductImageGalleryThumbnailsItem.defaultProps = {
  altDefault: undefined,
  classes: undefined,
  className: undefined,
  mediaTypeComponents: undefined,
  size: 'mini'
};
export default ProductImageGalleryThumbnailsItem;